/**
 * WebSocket authentication travels in `Sec-WebSocket-Protocol`, not the URL (CASA 2.1.1).
 *
 * Browsers cannot set headers on a WebSocket handshake, but they can offer subprotocols. A client
 * offers two: this marker, then its Clerk session token. The authorizer reads the token from the
 * header, and the `$connect` handler answers with the marker alone, which the browser requires
 * before it completes the connection. A token in the query string ends up in access logs, proxy
 * logs and browser history; a header does not.
 *
 * Rollout: clients still append `?token=` until API Gateway's identity source moves to this
 * header (WebSocket serverless.yml); then `webSocketUrlWithLegacyToken` goes.
 */
export const WEBSOCKET_AUTH_SUBPROTOCOL = 'thisandthat.auth';

export const webSocketAuthProtocols = (token: string): string[] => [
  WEBSOCKET_AUTH_SUBPROTOCOL,
  token,
];

/** Step 1 only: API Gateway still requires `?token=` until its identity source moves. */
export const webSocketUrlWithLegacyToken = (
  url: string,
  token: string,
): string => `${url}?token=${encodeURIComponent(token)}`;
